__turbopack_context__.v({
  "analyticsButton": "VaultCard-module__0j-Leq__analyticsButton",
  "apyColorShift": "VaultCard-module__0j-Leq__apyColorShift",
  "apyValue": "VaultCard-module__0j-Leq__apyValue",
  "backgroundGradient": "VaultCard-module__0j-Leq__backgroundGradient",
  "buttonRow": "VaultCard-module__0j-Leq__buttonRow",
  "cardContent": "VaultCard-module__0j-Leq__cardContent",
  "cardHeader": "VaultCard-module__0j-Leq__cardHeader",
  "contentSpace": "VaultCard-module__0j-Leq__contentSpace",
  "dataStream": "VaultCard-module__0j-Leq__dataStream",
  "dataStreamLeft": "VaultCard-module__0j-Leq__dataStreamLeft",
  "dataStreamRight": "VaultCard-module__0j-Leq__dataStreamRight",
  "depositButton": "VaultCard-module__0j-Leq__depositButton",
  "description": "VaultCard-module__0j-Leq__description",
  "headerContent": "VaultCard-module__0j-Leq__headerContent",
  "metricLabel": "VaultCard-module__0j-Leq__metricLabel",
  "metricRow": "VaultCard-module__0j-Leq__metricRow",
  "pulseGlow": "VaultCard-module__0j-Leq__pulseGlow",
  "riskBadge": "VaultCard-module__0j-Leq__riskBadge",
  "riskHigh": "VaultCard-module__0j-Leq__riskHigh",
  "riskLow": "VaultCard-module__0j-Leq__riskLow",
  "riskMedium": "VaultCard-module__0j-Leq__riskMedium",
  "statusIndicator": "VaultCard-module__0j-Leq__statusIndicator",
  "statusRow": "VaultCard-module__0j-Leq__statusRow",
  "statusText": "VaultCard-module__0j-Leq__statusText",
  "streamFlow": "VaultCard-module__0j-Leq__streamFlow",
  "tvlValue": "VaultCard-module__0j-Leq__tvlValue",
  "vaultCard": "VaultCard-module__0j-Leq__vaultCard",
  "vaultTitle": "VaultCard-module__0j-Leq__vaultTitle",
});
